<template>
  <v-container fluid class="approvals-filter-panel oms-list-filter">
    <div class="approvals-filter-row">
      <div class="approvals-filter-field approvals-filter-field--search">
        <v-text-field
          v-model="search"
          placeholder="Search by Anything"
          append-icon="search"
          single-line
          hide-details
          @keyup.enter="searchAnything"
        ></v-text-field>
      </div>
      <div
        class="approvals-filter-field approvals-filter-field--date wrapper"
        id="approvalDate"
      >
        <ejs-daterangepicker
          id="approvalPicker"
          :placeholder="waterMark"
          v-model="dateRange2"
          format="yyyy-MM-dd"
        ></ejs-daterangepicker>
      </div>
      <div class="approvals-filter-field approvals-filter-field--reset reset">
        <button
          type="button"
          class="approvals-reset-button"
          @click="reset"
        >
          <span>Reset</span>
          <v-icon>donut_large</v-icon>
        </button>
      </div>
    </div>
  </v-container>
</template>
<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import Vue from "vue";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";

Vue.use(DateRangePickerPlugin);
import { EventBus } from "../../event-bus.js";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  name: "approvalFilterCustomer",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      picker: {},
      waterMark: "Select a Range",
      dateRange2: null,
      startDate: "",
      endDate: "",
      dateRange: { startDate: "", endDate: "" },
      search: "",
      select: { country: "", abbr: "" },
    };
  },

  created() {
    EventBus.$on("countryChanged", (val) => {});
  },
  watch: {
    dateRange2(val) {
      if (val && val[0] && val[1]) {
        this.startDate = moment(val[0]).format("YYYY-MM-DD");
        this.endDate = moment(val[1]).format("YYYY-MM-DD");
        this.$emit("daterangenew-cust", val);
      } else if (!val) {
        this.startDate = "";
        this.endDate = "";
        this.$emit("daterangenew-cust", null);
      }
      // localStorage.setItem("approvalStartdate", this.dateRange.startDate);
      // localStorage.setItem("approvalEndDate", this.dateRange.endDate);
    },
  },
  methods: {
    reset() {
      // localStorage.removeItem("approvalSearch");
      // localStorage.removeItem("approvalStartdate");
      // localStorage.removeItem("approvalEndDate");

      this.$emit("customer-reset", {
        search: this.search,
        dateRange: this.dateRange,
      });
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
      this.dateRange2 = null;
      this.search = "";
    },
    startDateFilter() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        this.$emit("date-Filter", {
          startDate: this.startDate,
          endDate: this.endDate,
        });
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    searchAnything() {
      //localStorage.setItem("approvalSearch", this.search);
      this.$emit("customer-search", this.search);
    },
  },
};
</script>
<style scss>
#approvalDate .e-input-group-icon.e-range-icon.e-icons::after {
  content: none !important;
}

#approvalDate span.e-input-group-icon.e-range-icon.e-icons {
  margin-left: auto;
  position: static;
  text-align: center;
  width: auto;
}

#approvalDate {
  align-items: center !important;
  display: flex !important;
  height: 2.5rem !important;
}

#approvalDate .e-input-group,
#approvalDate .e-control-wrapper,
#approvalDate .e-date-range-wrapper {
  align-items: center !important;
  box-sizing: border-box !important;
  display: flex !important;
  height: 2.5rem !important;
  min-height: 2.5rem !important;
  padding: 0 0.75rem !important;
  width: 100% !important;
}

#approvalDate input.e-input,
#approvalDate .e-input {
  align-self: center !important;
  box-sizing: border-box !important;
  flex: 1 1 auto !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: 1.25rem !important;
  line-height: 1.25rem !important;
  margin: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
  vertical-align: middle !important;
}

#approvalDate .e-input-group-icon,
#approvalDate .e-control-wrapper .e-input-group-icon {
  align-items: center !important;
  align-self: center !important;
  display: inline-flex !important;
  height: 2.375rem !important;
  justify-content: center !important;
  line-height: 2.375rem !important;
  margin: 0 0 0 auto !important;
  min-height: 0 !important;
  padding: 0 !important;
  width: 1.25rem !important;
}

#approvalDate .e-input-group-icon.e-range-icon::before,
*.e-control-wrapper .e-input-group-icon.e-range-icon::before {
  content: "\e245";
  font-family: "e-icons";
  float: none;
  position: static;
}
#approvalPicker_popup.e-daterangepicker.e-popup {
  border-radius: 0.5rem !important;
  max-width: calc(100vw - 2rem) !important;
  min-width: 0 !important;
  overflow: hidden;
  width: auto !important;
}

#approvalPicker_popup.e-daterangepicker.e-popup .e-calendar,
.e-bigger.e-small #approvalPicker_popup.e-daterangepicker.e-popup .e-calendar {
  background-color: #fff;
  height: auto !important;
  max-width: 17.5rem !important;
  min-width: 17.5rem !important;
  width: 17.5rem !important;
}

#approvalPicker_popup .e-calendar .e-header {
  min-height: 2.25rem !important;
  padding: 0.375rem 0.5rem !important;
}

#approvalPicker_popup .e-calendar .e-content {
  padding: 0.25rem 0.5rem 0.5rem !important;
}

#approvalPicker_popup .e-calendar .e-content table {
  font-size: 0.75rem !important;
  table-layout: fixed !important;
  width: 100% !important;
}

#approvalPicker_popup .e-calendar .e-content td {
  height: 2.125rem !important;
  padding: 0.125rem !important;
}

#approvalPicker_popup .e-calendar .e-content td span {
  font-size: 0.75rem !important;
  height: 1.875rem !important;
  line-height: 1.875rem !important;
  width: 1.875rem !important;
}

#approvalPicker_popup .e-footer,
#approvalPicker_popup .e-footer-container {
  min-height: 2.5rem !important;
  padding: 0.5rem 0.75rem !important;
}

#approvalPicker_popup .e-btn {
  font-size: 0.75rem !important;
  height: 2rem !important;
  line-height: 1 !important;
}
#approvalDate .e-clear-icon {
  display: none !important;
  opacity: 0;
}

@media (max-width: 48rem) {
  #approvalPicker_popup.e-daterangepicker.e-popup .e-calendar,
  .e-bigger.e-small #approvalPicker_popup.e-daterangepicker.e-popup .e-calendar {
    max-width: 14.5rem !important;
    min-width: 14.5rem !important;
    width: 14.5rem !important;
  }
}
</style>
<style scoped>
.approvals-filter-panel {
  background: linear-gradient(180deg, #ffffff 0%, #fbfaf7 100%);
  border: 0.0625rem solid var(--approvals-border, #e4e1d9);
  border-bottom: 0;
  border-radius: 0.5rem 0.5rem 0 0;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  margin: 0 var(--oms-section-x, 1.875rem) !important;
  max-width: none;
  padding: 1.125rem 0.875rem !important;
}

.approvals-filter-row {
  --approvals-filter-control-height: 2.5rem;
  align-items: center;
  display: grid !important;
  gap: 0.75rem;
  grid-template-columns: minmax(15rem, 24rem) minmax(17rem, 24rem) 5.5rem;
  justify-content: center;
  margin: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 56.25rem;
  width: 100%;
}

.approvals-filter-field {
  align-items: center;
  align-self: center;
  box-sizing: border-box;
  display: flex;
  height: var(--approvals-filter-control-height);
  min-width: 0;
  width: 100%;
}

.approvals-filter-field--reset {
  align-items: center;
  display: flex;
  float: none !important;
  justify-self: start;
  margin-top: 0 !important;
  width: 5.5rem;
}

.approvals-filter-row ::v-deep .v-input,
.approvals-filter-row ::v-deep .v-text-field,
.approvals-filter-row ::v-deep .wrapper,
.approvals-filter-row ::v-deep .e-input-group,
.approvals-filter-row ::v-deep .e-control-wrapper {
  box-sizing: border-box !important;
  height: var(--approvals-filter-control-height) !important;
  margin: 0 !important;
  min-height: var(--approvals-filter-control-height) !important;
  padding-top: 0 !important;
  width: 100% !important;
}

.approvals-filter-row ::v-deep .v-input__slot,
.approvals-filter-row ::v-deep .e-input-group,
.approvals-filter-row ::v-deep .e-control-wrapper {
  align-items: center !important;
  background: #ffffff !important;
  border: 0.0625rem solid #dbe2ec !important;
  border-radius: 0.5rem !important;
  box-sizing: border-box !important;
  box-shadow: inset 0 0.0625rem 0 rgba(26, 25, 22, 0.03) !important;
  display: flex !important;
  height: var(--approvals-filter-control-height) !important;
  min-height: var(--approvals-filter-control-height) !important;
  padding: 0 0.75rem !important;
}

#approvalDate ::v-deep .e-input-group,
#approvalDate ::v-deep .e-control-wrapper {
  align-items: center !important;
  display: flex !important;
  line-height: var(--approvals-filter-control-height) !important;
  padding: 0 0.75rem !important;
}

#approvalDate ::v-deep .e-input-group .e-input,
#approvalDate ::v-deep .e-control-wrapper .e-input {
  align-self: center !important;
  flex: 1 1 auto !important;
  height: 1.25rem !important;
  line-height: 1.25rem !important;
  min-height: 0 !important;
  padding: 0 !important;
}

#approvalDate ::v-deep .e-input-group-icon,
#approvalDate ::v-deep .e-control-wrapper .e-input-group-icon {
  align-items: center !important;
  align-self: center !important;
  display: inline-flex !important;
  height: calc(var(--approvals-filter-control-height) - 0.125rem) !important;
  justify-content: center !important;
  line-height: calc(var(--approvals-filter-control-height) - 0.125rem) !important;
  margin: 0 0 0 auto !important;
  min-height: 0 !important;
  padding: 0 !important;
  width: 1.25rem !important;
}

.approvals-filter-row ::v-deep .v-input__control {
  box-sizing: border-box !important;
  height: var(--approvals-filter-control-height) !important;
  min-height: var(--approvals-filter-control-height) !important;
}

.approvals-filter-field--search ::v-deep .v-text-field__slot {
  align-items: center !important;
  display: flex !important;
}

.approvals-filter-row ::v-deep .v-text-field .v-input__slot {
  margin-bottom: 0 !important;
}

.approvals-filter-row ::v-deep .v-text-field .v-input__slot::before,
.approvals-filter-row ::v-deep .v-text-field .v-input__slot::after {
  display: none !important;
}

.approvals-filter-row ::v-deep .v-input__append-inner {
  align-self: center !important;
  margin-top: 0 !important;
}

.approvals-filter-row ::v-deep .v-text-field__details {
  display: none;
}

.approvals-filter-row ::v-deep .v-text-field input,
.approvals-filter-row ::v-deep .e-input {
  color: #334155 !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600;
  height: 1.25rem !important;
  line-height: 1.25rem !important;
  margin: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
  vertical-align: middle !important;
}

.approvals-filter-row ::v-deep input::placeholder,
.approvals-filter-row ::v-deep .e-input-group input::placeholder {
  color: #334155 !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600;
  opacity: 1 !important;
}

#approvalDate ::v-deep input,
#approvalDate ::v-deep .e-input,
#approvalDate ::v-deep .e-input::placeholder,
#approvalDate ::v-deep input::placeholder {
  color: #334155 !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
}

.approvals-filter-row ::v-deep .v-label {
  display: none !important;
}

.approvals-filter-row ::v-deep .v-icon,
.approvals-filter-row ::v-deep .e-input-group-icon {
  color: #64748b !important;
  font-size: 1.125rem !important;
}

.reset {
  float: none !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  text-align: center;
}

.approvals-reset-button {
  align-items: center !important;
  appearance: none;
  background: #ffffff !important;
  border: 0.0625rem solid #dbe2ec !important;
  border-radius: 0.5rem !important;
  box-sizing: border-box;
  color: var(--approvals-primary-dark, #d96a10) !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600;
  gap: 0.25rem;
  height: var(--approvals-filter-control-height) !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  max-height: var(--approvals-filter-control-height) !important;
  max-width: 5.5rem;
  min-height: var(--approvals-filter-control-height) !important;
  min-width: 0;
  padding: 0 0.375rem !important;
  text-transform: none;
  white-space: nowrap;
  width: 5.5rem !important;
}

.approvals-reset-button .v-icon {
  color: var(--approvals-primary, #ea7a1c) !important;
  font-size: 0.75rem !important;
  height: 0.75rem;
  line-height: 0.75rem;
  margin-left: 0;
  width: 0.75rem;
}

@media (max-width: 47.5rem) {
  .approvals-filter-panel {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  .reset {
    margin-left: 0;
    width: 100%;
  }
}

@media (max-width: 64rem) {
  .approvals-filter-row {
    grid-template-columns: 1fr;
    max-width: none;
  }
}
</style>
